import { RouteInfo } from './sellersidebar.metadata';

export const ROUTES: RouteInfo[] = [
  //   {
  //     path: '',
  //     title: 'Personal',
  //     icon: 'mdi mdi-dots-horizontal',
  //     class: 'nav-small-cap',
  //     extralink: true,
  //     submenu: []
  //   },
    {
      path: '/seller/dashboard',
      title: 'Dashboard',
      icon: 'icon-Dashboard',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/viewInventory',
      title: 'Inventory',
      icon: 'icon-Add-Cart',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/mr',
      title: 'Material Request',
      icon: 'icon-Books-2',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/proforma',
      title: 'Proforma Invoice',
      icon: 'icon-Mailbox-Full',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/po',
      title: 'Purchase Order',
      icon: 'icon-Full-Cart',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/invoice',
      title: 'Invoice',
      icon: 'icon-Receipt-3',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/invoiceDiscount',
      title: 'Discounted Invoices',
      icon: 'icon-Money-2',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/reconciliation',
      title: 'Payment Reconciliation',
      icon: 'icon-Money-2',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/list/retailer',
      title: 'Counter Party',
      icon: 'icon-Checked-User',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/agreement',
      title: 'Agreement',
      icon: 'fas fa-pencil-alt',
      class: '',
      extralink: false,
      submenu: []
    },
  ];

export const ROUTESproductCategory: RouteInfo[] =  [
  //   {
  //     path: '',
  //     title: 'Personal',
  //     icon: 'mdi mdi-dots-horizontal',
  //     class: 'nav-small-cap',
  //     extralink: true,
  //     submenu: []
  //   },
    {
      path: '/seller/dashboard',
      title: 'Dashboard',
      icon: 'icon-Dashboard',
      class: '',
      extralink: false,
      submenu: []
    },
    // {
    //   path: '/seller/viewInventory',
    //   title: 'Inventory',
    //   icon: 'icon-Add-Cart',
    //   class: '',
    //   extralink: false,
    //   submenu: []
    // },
    // {
    //   path: '/seller/mr',
    //   title: 'Material Request',
    //   icon: 'icon-Books-2',
    //   class: '',
    //   extralink: false,
    //   submenu: []
    // },
    // {
    //   path: '/seller/proforma',
    //   title: 'Proforma Invoice',
    //   icon: 'icon-Mailbox-Full',
    //   class: '',
    //   extralink: false,
    //   submenu: []
    // },
    // {
    //   path: '/seller/po',
    //   title: 'Purchase Order',
    //   icon: 'icon-Full-Cart',
    //   class: '',
    //   extralink: false,
    //   submenu: []
    // },
    {
      path: '/seller/manual_invoice_list',
      title: 'Invoice',
      icon: 'icon-Receipt-3',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/invoiceDiscount',
      title: 'Discounted Invoices',
      icon: 'icon-Money-2',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/reconciliation',
      title: 'Payment Reconciliation',
      icon: 'icon-Money-2',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/list/retailer',
      title: 'Counter Party',
      icon: 'icon-Checked-User',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/seller/agreement',
      title: 'Agreement',
      icon: 'fas fa-pencil-alt',
      class: '',
      extralink: false,
      submenu: []
    },
  ];

